import React, { FunctionComponent } from 'react'

interface Props {
  numberOfCustomers: number
}

const Metrics: FunctionComponent<Props> = props => {
  return (
    <React.Fragment>
      <div id='stat-customers' className='col'>
        <h5>Customers</h5>
        <div className='num'>{props.numberOfCustomers}</div>
      </div>
    </React.Fragment>
  )
}

export default Metrics
